import { FC, MouseEvent } from 'react'
import { Button } from 'rsuite'

import ArrowStrokeWhite from '../Icons/ArrowStrokeWhite'

import styles from '../../styles/ImageNavigationArrow.module.less'

interface ImageNavigationArrowProps {
  isVisible: boolean
  onClick: (event: MouseEvent<HTMLButtonElement>) => void
}

const ImageNavigationArrow: FC<ImageNavigationArrowProps> = ({
  isVisible,
  onClick,
}) => {
  if (!isVisible) return null

  return (
    <Button
      appearance="subtle"
      size="xs"
      className={styles['image-nav-arrow']}
      onClick={onClick}
    >
      <ArrowStrokeWhite />
    </Button>
  )
}

export default ImageNavigationArrow
